import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import SmoothScroll from "@/components/SmoothScroll";
import CustomCursor from "@/components/CustomCursor";
import Layout from "@/components/layout/Layout";

import Home from "@/pages/Home";
import WhoWeAre from "@/pages/WhoWeAre";
import WorkIndex from "@/pages/WorkIndex";
import CaseStudy from "@/pages/CaseStudy";
import Connect from "@/pages/Connect";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen bg-bg flex items-center justify-center text-muted2">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

const withLayout = (el) => <Layout>{el}</Layout>;

function App() {
  return (
    <div>
      <AuthProvider>
        <BrowserRouter>
          <SmoothScroll>
            <CustomCursor />
            <Toaster theme="light" position="bottom-right" toastOptions={{ style: { background: "#FFFFFF", border: "1px solid #E5E5E5", color: "#000000" } }} />
            <Routes>
              <Route path="/" element={withLayout(<Home />)} />
              <Route path="/work" element={withLayout(<WorkIndex />)} />
              <Route path="/work/:slug" element={withLayout(<CaseStudy />)} />
              <Route path="/services" element={<Navigate to="/#services" replace />} />
              <Route path="/about" element={withLayout(<WhoWeAre />)} />
              <Route path="/connect" element={withLayout(<Connect />)} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </SmoothScroll>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
